import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, ViewEncapsulation } from '@angular/core';
import { Store } from '@ngrx/store';
import { GetExtensionDetail_extension_extensionQueue } from '../../queries/generated/GetExtensionDetail';
import { logAgentOutOfQueue } from '../../state/extension-detail.actions';

@Component({
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'ndt-extension-queue-detail-left-column',
    styleUrls: ['./extension-queue-detail-left-column.component.scss', '../extension-detail-view.component.scss'],
    templateUrl: './extension-queue-detail-left-column.component.html',
    standalone: false
})
export class ExtensionQueueDetailLeftColumnComponent {
   @Input() extensionQueue: GetExtensionDetail_extension_extensionQueue | null;

   get distinctAgents() {
      if (!this.extensionQueue?.queueMembersConnection.items) return [];
      return this.extensionQueue.queueMembersConnection.items.filter(
         (agent, index, self) =>
            index === self.findIndex((a) => a.agentExtension.extensionId === agent.agentExtension.extensionId)
      );
   }
   getStatus(status: string, endWrapUpTime?: Date): string {
      if (status === 'Available') {
         if (endWrapUpTime) {
            const now = new Date();
            const wrapUpEnd = new Date(endWrapUpTime);

            if (wrapUpEnd > now) {
               return 'Wrap Up';
            } else {
               return 'Available';
            }
         }
         return 'Available';
      }

      return status;
   }

   oneSecondInterval: any;
   constructor(private cdr: ChangeDetectorRef, private store: Store) {
      this.store = store;
      this.oneSecondInterval = setInterval(() => {
         this.cdr.markForCheck();
      }, 1000);
   }
   onLogOutAgentClick(agent: any) {
      this.store.dispatch(
         logAgentOutOfQueue({
            queueMemberId: agent.queueMemberId,
            extensionName: agent.agentExtension.name,
         })
      );
   }
}
